{
  "contactModal": {
    "delete": {
      "cancel": "İptal",
      "confirm": "Sil",
      "error": {
        "contactWithInformationRequests": "contactWithInformationRequests",
        "default": "default",
        "title": "title"
      },
      "message": "Bu kişiyi silmek istediğinizden emin misiniz?",
      "success": "success",
      "title": "Kişiyi Sil"
    }
  },
  "contacts": {
    "buttons": {
      "add": "Kişi Ekle"
    },
    "table": {
      "headers": {
        "actions": "İşlemler",
        "email": "E-posta",
        "id": "ID",
        "name": "Ad"
      }
    }
  },
  "productionSiteModal": {
    "actions": {
      "cancel": "İptal",
      "delete": "Sil",
      "save": "Kaydet"
    },
    "createTitle": "Yeni üretim sitesi",
    "delete": {
      "cancel": "İptal",
      "confirm": "Sil",
      "message": "Bu üretim sitesini silmek istediğinizden emin misiniz?",
      "title": "Üretim Sitesini Sil"
    },
    "editTitle": "Üretim Sitesi Düzenle",
    "errors": {
      "cityRequired": "Şehir gereklidir",
      "coordinatesMaxDecimals": "Enlem ve boylam en fazla 6 ondalik basamaga sahip olabilir",
      "countryMustBeValid": "Ülke geçerli olmalıdır (örn. FR, DE)",
      "internalCodeTooLong": "Dahili kod en fazla 32 karakter olmalıdır",
      "nameRequired": "Ad gereklidir",
      "parentCompanyRequired": "parentCompanyRequired",
      "postalCodeTooShort": "Posta kodu en az 3 karakter olmalıdır",
      "streetRequired": "Caddesi gereklidir",
      "streetTooShort": "Caddesi en az 3 karakter olmalıdır"
    },
    "labels": {
      "city": "Şehir",
      "country": "Ülke",
      "internalCode": "Dahili kod",
      "latitude": "Enlem",
      "longitude": "Boylam",
      "name": "Üretim sitesi adı",
      "parentCompany": "Ana şirket",
      "performedActivities": "Yapılan faaliyetler",
      "postalCode": "Posta kodu",
      "registrationId": "Tesis kayıt kimlikleri",
      "street": "Sokak"
    },
    "placeholders": {
      "city": "örn. İstanbul",
      "country": "Tesisin bulunduğu ülkeyi seçin",
      "internalCode": "örn. BD-DAK-001 veya dahili referansınız",
      "latitude": "örn. 41.0082",
      "longitude": "örn. 28.9784",
      "name": "örn. Dakka Kesim ve Dikiş Ünitesi A",
      "performedActivities": "örn. Kesim, dikiş, bitirme, boyama",
      "postalCode": "örn. 34000",
      "registrationId": "örn. KDV no, CIN, GSTIN, USC",
      "street": "örn. İstiklal Caddesi 10"
    },
    "registrationIdDescriptions": {
      "DUNS": "DUNS: 9 hane.",
      "EORI": "EORI: ülke kodu + 14 hane.",
      "GLN": "GLN: 13 hane.",
      "OTHER": "Diğer: en fazla 32 karakter.",
      "RCS": "RCS: RCS + boşluk + şirket adı + boşluk + [A,B] + boşluk + 9 hane.",
      "VAT": "VAT: ülke kodu (örn. FR) + 2 hane + 9 hane SIREN."
    },
    "registrationIdErrors": {
      "DUNS": "DUNS kayıt kimliği 9 haneli bir numara olmalıdır.",
      "EORI": "EORI kayıt kimliği şu formatta olmalıdır: ülke kodu (örn. FR) + 14 hane.",
      "GLN": "GLN kayıt kimliği 13 haneli bir numara olmalıdır.",
      "OTHER": "Diğer kayıt kimliği 32 karakterden az olmalıdır.",
      "RCS": "RCS kayıt kimliği şu formatta olmalıdır: RCS + boşluk + şirket adı + boşluk + [A,B] + boşluk + 9 hane.",
      "VAT": "VAT kayıt kimliği şu formatta olmalıdır: ülke kodu (örn. FR) + 2 haneli anahtar + 9 haneli SIREN numarası."
    },
    "tabs": {
      "generalInfo": "Genel bilgiler",
      "location": "Konum"
    },
    "tooltips": {
      "address": "Üretim sitesi adresi",
      "city": "Üretim sitesinin şehri",
      "country": "Üretim sitesinin ülkesi",
      "internalCode": "Üretim sitesinin dahili kodu",
      "latitude": "Üretim sitesinin enlemi",
      "longitude": "Üretim sitesinin boylamı",
      "name": "Üretim sitesi adı",
      "parentCompany": "parentCompany",
      "performedActivities": "Üretim sitesinde yapılan faaliyetler",
      "postalCode": "Üretim sitesinin posta kodu",
      "registrationId": "Üretim sitesi kayıt kimlikleri",
      "street": "Üretim sitesinin sokağı"
    }
  },
  "productionSites": {
    "buttons": {
      "add": "Üretim Sitesi Ekle"
    },
    "create": {
      "error": "Üretim sitesi oluşturulurken hata oluştu",
      "success": {
        "message": "Üretim sitesi başarıyla oluşturuldu",
        "title": "Üretim sitesi oluşturuldu"
      }
    },
    "delete": {
      "error": "Üretim sitesi silinirken hata oluştu",
      "success": {
        "message": "Üretim sitesi başarıyla silindi",
        "title": "Üretim sitesi silindi"
      }
    },
    "filters": {
      "country": "Ülke",
      "internalCode": "Dahili kod",
      "isConfidential": "Gizli",
      "isConfidentialFalse": "Hayır",
      "isConfidentialTrue": "Evet",
      "name": "Üretim sitesi adı",
      "nothingFoundMessage": "nothingFoundMessage",
      "performedActivities": "Yapılan faaliyetler",
      "searchPlaceholder": "Ara filtreler",
      "title": "Filtreler"
    },
    "search": {
      "placeholder": "placeholder"
    },
    "sorts": {
      "address": "address",
      "country": "Ülke",
      "email": "Email",
      "internalCode": "internalCode",
      "name": "Ad"
    },
    "table": {
      "headers": {
        "address": "Adres",
        "certificates": "Sertifikalar",
        "deleted": "Silindi",
        "id": "ID",
        "internalCode": "Dahili kod",
        "name": "Ad",
        "parentCompany": "parentCompany",
        "performedActivities": "Yapılan faaliyetler",
        "registrationId": "Tesis kayıt kimlikleri"
      }
    },
    "title": "Üretim Siteleri",
    "update": {
      "error": "Üretim sitesi güncellenirken hata oluştu",
      "success": {
        "message": "Üretim sitesi başarıyla güncellendi",
        "title": "Üretim sitesi güncellendi"
      }
    }
  },
  "request": {
    "errors": {
      "generic": "Hata"
    }
  }
}
